export enum RecipientType {
  to = 0,
  cc = 1,
  bcc = 2
}